/**
 * Level 1
 */
export const ROOTS_DASHBOARD = 'dashboard';

// ----------------------------------------------------------------------

/**
 * Level 2
 */
export const FOSTER_FAMILIES = 'foster-families';
export const CLIENTS = 'clients';
export const CUSTOMERS = 'customers';
export const USERS = 'users';
export const COMPANY = 'company';

// ----------------------------------------------------------------------

/**
 * Level 3
 */
export const LIST = 'list';
export const NEW = 'new';

// ----------------------------------------------------------------------

/**
 * Level 4
 */
export const HOME = 'home';
export const PROFILE = 'profile';
export const DOCUMENTS = 'documents';
export const VAULT = 'vault';
export const PLACEMENTS = 'placements';
export const CHANGE_PASSWORD = 'change-password';
export const ALL = 'all';
export const ACTIVE = 'active';
export const INACTIVE = 'inactive';
export const INACTIVATED = 'inactivated';
export const END = 'end';
export const ENDED = 'ended';
export const FULL = 'full';
export const READY = 'ready';
export const PENDING = 'pending';

// ----------------------------------------------------------------------
